module.exports = __webpack_public_path__ + "static/images/containers/BuildingsCarousel/images/pattern.d886abc3.png";


//////////////////
// WEBPACK FOOTER
// ./containers/BuildingsCarousel/images/pattern.png
// module id = 2811
// module chunks = 11